<template>
  <v-container>
    <v-row class="mb-4">
      <v-col
        cols="12"
        md="10">
        <v-checkbox
          label="Don't receive notifications"
          :color="etapColor"
          v-model="notificationsDisabled"
          @change="toggleNotification"/>
        <v-text-field
          v-model="searchMessage"
          label="Search messages"
          prepend-inner-icon="mdi-magnify"
          :color="etapColor"
          outlined
          dense
          clearable
        />
      </v-col>
      <v-col
        cols="12"
        md="2">
        <v-select
          v-model="orderModel"
          :color="etapColor"
          item-color="teal"
          :items="orderByArray"
          item-text="title"
          item-value="value"
          label="Sort by"
          outlined
          dense
          @change="sortMessages"
        />
      </v-col>
    </v-row>

    <v-row v-if="filteredMessages.length > 0">
      <v-col
        v-for="message in filteredMessages"
        :key="message.id"
        cols="12">
        <v-card :style="{ borderLeft: `4px solid ${message.textcolor || '#000000'}` }">
          <v-card-title class="pb-3">
            <span
              class="text-h6"
              :style="{ color: message.textcolor || '#000000'}">
              {{ message.title }}
            </span>
            <v-spacer/>
            <v-chip
              small
              outlined>{{ formatDate(message.date) }}</v-chip>
          </v-card-title>

          <v-card-text>
            <div
              v-html="message.message"
              :style="{ color: message.textcolor || '#000000' }"
              class="message-content mb-3"
            />

            <v-divider
              v-if="message.files && message.files.length > 0"
              class="my-3"/>

            <div v-if="message.files && message.files.length > 0">
              <div class="text-subtitle-2 mb-2">
                <v-icon
                  small
                  left>mdi-paperclip</v-icon>
                Attachments
              </div>
              <v-chip
                v-for="file in message.files"
                :key="file.id"
                :href="file.href"
                target="_blank"
                small
                class="mr-2 mb-2 white--text"
                :color="etapColor"
              >
                <v-icon
                  small
                  left>mdi-file-download</v-icon>
                {{ file.filename }}
              </v-chip>
            </div>

            <div class="text-caption text--secondary mt-3">
              <v-icon
                small
                left>mdi-account</v-icon>
              {{ message.teacher }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col
        cols="12"
        class="text-center py-8">
        <v-icon
          size="64"
          color="grey lighten-1">mdi-message-off-outline</v-icon>
        <p class="text-h6 grey--text text--lighten-1 mt-4">
          {{ searchMessage ? 'No messages found matching your search' : 'No sports messages available' }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    messages: [],
    searchMessage: '',
    orderModel: 'dateDesc',
    orderByArray: [
      { title: 'Newest First', value: 'dateDesc' },
      { title: 'Oldest First', value: 'dateAsc' },
      { title: 'Title A-Z', value: 'titleAsc' },
      { title: 'Title Z-A', value: 'titleDesc' }
    ],
    notificationsDisabled: false
  }),

  computed: {
    etapColor () {
      return this.$store.state.etapColor || 'teal'
    },

    filteredMessages () {
      let filtered = this.messages

      if (this.searchMessage) {
        const search = this.searchMessage.toLowerCase()
        filtered = filtered.filter(msg =>
          msg.title.toLowerCase().includes(search) ||
          msg.message.toLowerCase().includes(search) ||
          (msg.teacher && msg.teacher.toLowerCase().includes(search))
        )
      }

      return filtered
    }
  },

  methods: {
    toggleNotification () {
      const action = this.notificationsDisabled ? 'disable' : 'enable'

      this.$http.post(`sportsMessages/${this.$store.state.Dbasename}/${this.$store.state.pupilId}/${action}`)
        .then(response => {
          console.log(response.data)
        })
        .catch(error => {
          console.error('Error toggling notifications:', error)
          this.notificationsDisabled = !this.notificationsDisabled
        })
    },
    loadNotificationStatus () {
      this.$http.get(`sportsMessages/${this.$store.state.Dbasename}/${this.$store.state.pupilId}/status`)
        .then(response => {
          this.notificationsDisabled = response.data.disabled
        })
        .catch(error => {
          console.log('Error loading notification status:', error)
        })
    },
    sortMessages () {
      const sorted = [...this.messages]

      switch (this.orderModel) {
        case 'dateDesc':
          sorted.sort((a, b) => new Date(b.date) - new Date(a.date))
          break
        case 'dateAsc':
          sorted.sort((a, b) => new Date(a.date) - new Date(b.date))
          break
        case 'titleAsc':
          sorted.sort((a, b) => a.title.localeCompare(b.title))
          break
        case 'titleDesc':
          sorted.sort((a, b) => b.title.localeCompare(a.title))
          break
      }

      this.messages = sorted
    },

    formatDate (date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    }
  },

  created () {
    this.loadNotificationStatus()
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      vm.$http.get('sportsMessages/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId)
        .then(response => {
          vm.messages = response.data
          vm.sortMessages()
          vm.$store.commit('loading', false)
        })
        .catch(error => {
          console.error('Error loading sports messages:', error)
          vm.$store.commit('loading', false)
        })
    })
  },

  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>

<style scoped>
.message-content {
  line-height: 1.6;
}

.message-content >>> p {
  margin-bottom: 0.5em;
}

.message-content >>> ul,
.message-content >>> ol {
  margin-left: 1.5em;
}
</style>
